const doc = [({"da":({"js":({"merfoto":({"token":({"enter_token":"Indtast token", "your_token_was_added_to_your_contact":"Token blev tilføjet til din kontakt."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;